module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "OverlayToggle",
    class: _vm.classes
  }, [_c('p', {
    staticClass: "OverlayToggle-label",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "OverlayToggle-icon",
    style: (_vm.iconStyles),
    attrs: {
      "name": "plus",
      "width": "11px",
      "height": "11px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61947295"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverlayToggle.vue
// module id = 773
// module chunks = 1474